import { GroupState } from '@/composition/groups'
import { InvitationState } from '@/composition/invitations'
import { LearningState } from '@/composition/learning'
import { useGlobalStore } from '@/store/app'
import { isGokollab } from '@ghl/clientportal-core/init'

export function getCurrentTabDataHelper(
  activeMenuItem,
  currentData,
  originalData
) {
  switch (activeMenuItem) {
    case 'GroupDetails':
      return {
        ...originalData,
        name: currentData.name,
        description: currentData.description,
        slug: currentData.slug,
        settings: {
          ...originalData.settings,
          groupType: currentData.settings?.groupType,
          groupSwitcherVisibility:
            currentData.settings?.groupSwitcherVisibility,
          allowsMembersInvite: currentData.settings?.allowsMembersInvite,
          showMandatoryInfoModal: currentData.settings?.showMandatoryInfoModal,
        },
      }
    case 'GroupSubscriptions':
      return {
        ...originalData,
        settings: {
          ...originalData.settings,
          membership: currentData.settings?.membership
            ? {
                membershipType: currentData.settings.membership.membershipType,
                subscriptionType:
                  currentData.settings.membership.subscriptionType,
                subscriptionInterval:
                  currentData.settings.membership.subscriptionInterval,
                price: currentData.settings.membership.price,
                isLivePayment: currentData.settings.membership.isLivePayment,
                trialDays: currentData.settings.membership.trialDays,
                currency: currentData.settings.membership.currency,
                paymentPriceId:
                  originalData.settings?.membership?.paymentPriceId,
                paymentProductId:
                  originalData.settings?.membership?.paymentProductId,
                locationName: originalData.settings?.membership?.locationName,
              }
            : originalData.settings?.membership,
        },
      }
    case 'GroupBranding':
      return {
        ...originalData,
        branding: currentData.branding,
        settings: {
          ...originalData.settings,
          customCode: currentData.settings?.customCode,
        },
      }
    case 'GroupAppearance':
      return {
        ...originalData,
        branding: {
          ...originalData.branding,
          color: currentData.branding?.color,
        },
      }
    case 'Discovery':
      return {
        ...originalData,
        marketplaceGroupSlug: currentData.marketplaceGroupSlug,
      }
    case 'MembershipQuestions':
      return {
        ...originalData,
        settings: {
          ...originalData.settings,
          membershipQuestionsEnabled:
            currentData.settings?.membershipQuestionsEnabled,
        },
      }
    case 'GroupNewsletter':
      return {
        ...originalData,
        settings: {
          ...originalData.settings,
          newsletter: currentData.settings?.newsletter,
        },
      }
    default:
      return currentData
  }
}

export function getGroupSlugFromUrl(url: string) {
  const groupSlug = isGokollab() ? url.split('/')[0] : url.split('/')[2]
  return groupSlug
}

// export function redirectToGroup(groupSlug: string) {
//   const globalStore = useGlobalStore()
//   globalStore.setGroupId('')
//   GroupState.state.groupData = {} as any
//   router.push({ name: 'home', params: { groupSlug: groupSlug } })
// }

export function resetGroupData(): void {
  const globalStore = useGlobalStore()
  GroupState.state.fetchingGroupData = true

  globalStore.setGroupId('')
  GroupState.resetState()
  LearningState.resetState()
  InvitationState.resetState()
  // Set group data loading state to prevent showing old data during group switch
}
